import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import queryClient from "api/queryClient.ts";
import { getFormStructureQueryOptions } from "api/TenantSlug/FormStructure/queryOptions.ts";
import { COMMON_GET_FORM_STRUCTURE_QUERY_FILTERS } from "api/TenantSlug/FormStructure/queryOptions.ts";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";
import { isAxiosErrorOfStatus } from "utils/isAxiosErrorOfStatus.ts";

export const Route = createFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout"
)({
    loader: async ({ params }) => {
        const { formStructureId, tenantSlug } = params;

        let breadcrumb = formStructureId;

        try {
            const { formStructure } = await queryClient.ensureQueryData(
                getFormStructureQueryOptions(formStructureId, COMMON_GET_FORM_STRUCTURE_QUERY_FILTERS)
            );

            breadcrumb = formStructure.name;
        } catch (error) {
            if (isAxiosErrorOfStatus(error, 404)) {
                throw redirect({
                    to: "/$tenantSlug/tool/structure/lead",
                    params: { tenantSlug },
                });
            }
        }

        return {
            breadcrumb,
        };
    },
    pendingComponent: () => <QueryState isLoading={true} isError={false} />,
    errorComponent: () => <QueryState isLoading={false} isError={true} errorKey="errors.loading_form_structure" />,
    component: () => <Outlet />,
});
